export default "__VITE_ASSET__BXmjfnrS__"